import * as React from 'react';
import { AddToShoppingCartButton, ShoppingCartContext, WSAppContext } from '@weddingspot/ws-core-components';
import * as analytics from '@weddingspot/ws-analytics';

const styles = require('./ShoppingCartCTAButton.scss');

interface Props {
    venueId: number;
    venueName: string;
    venueLocation: string;
    venueImageUrl?: string;
    handleAddVenueToShoppingCart?: () => void;
    handleRemoveVenueFromShoppingCart?: () => void;
    sourcePage?: string;
    venueContractPackage?: string;
}

export const ShoppingCartCTAButton = (props: Props) => {
    const { items, addItem, removeItem } = React.useContext(ShoppingCartContext);
    const { getSRPViewFromSessionStorage } = React.useContext(WSAppContext);

    const addVenue = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        const value = {
            id: props.venueId,
            name: props.venueName,
            location: props.venueLocation,
            imageUrl: props.venueImageUrl,
            lastUpdated: new Date().getTime(),
            srpView: getSRPViewFromSessionStorage(props.venueId),
            contractPackage: props.venueContractPackage,
        };
        addItem(value).then(() => {
            !!props.handleAddVenueToShoppingCart && props.handleAddVenueToShoppingCart();
        });
        if (props.sourcePage) {
            analytics.logEvent(analytics.AnalyticsEvent.EVTNM_VENUE_ADDED_TO_CART, { source: props.sourcePage, venueId: value.id });
        }
    };

    const removeVenue = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        removeItem(props.venueId).then(() => {
            !!props.handleRemoveVenueFromShoppingCart && props.handleRemoveVenueFromShoppingCart();
        });
        if (props.sourcePage) {
            analytics.logEvent(analytics.AnalyticsEvent.EVTNM_VENUE_REMOVE_FROM_CART, { source: props.sourcePage, venueId: props.venueId });
        }
    };

    return (
        <div className={styles.ctaShoppingCartButton}>
            <AddToShoppingCartButton
                isInCart={!!items.find((i) => i.id === props.venueId)}
                removeVenue={removeVenue}
                addVenue={addVenue}
                nonPrimary={true}
            />
        </div>
    );
};
